import React from 'react';
import { BellOff } from 'lucide-react';

/**
 * Leading-icon warning callout: outbound work-pass alerts are held.
 * Icon anchors title + description only (DS indent-scope rule).
 */
const WorkPassNotificationsPausedBanner = ({ paused }) => {
  if (!paused) return null;

  return (
    <div
      className="rounded-2xl border border-amber-200 bg-amber-50/40 p-4 sm:p-5"
      role="status"
    >
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
          <BellOff className="w-4 h-4 text-amber-700" aria-hidden="true" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-gray-900">
            WhatsApp and email are paused
          </p>
          <p className="mt-0.5 text-xs text-gray-700 leading-relaxed">
            Work-pass alerts will not message you one worker at a time. When they
            resume, you get one morning digest of your queue — not a blast.
          </p>
        </div>
      </div>
    </div>
  );
};

export default WorkPassNotificationsPausedBanner;
